import { VscLocation, VscMail } from "react-icons/vsc";
import ContactForm from "./ContactForm";
import React, {useContext} from 'react';
import ThemeContext from '../../store/theme-context';
import SocialMedia from "./SocialMedia";
const Contact = () => {
    const theme = useContext(ThemeContext);
    return ( 
        
        <div style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}>
        <h2 className="sectionHeading">LET'S CATCHUP </h2>
        <div className="contact">
            <div className="contactForm">
                <ContactForm/>
            </div>
            <div className="contactInfo">
                <div className="contactDetails">
                    <VscLocation size={25}/>
                    <h3 style={{display:"inline"}}>Delhi NCR</h3>
                </div>
                <div className="contactDetails">
                    <VscMail size={22}/>
                    <h3 style={{marginLeft:"5px"}}>info@shahbazkhan.in</h3>
                </div>
            </div>
            
        </div>

        <div className="follow" style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}>
        <h2 className="sectionHeading">FOLLOW HERE </h2>
            <SocialMedia/>
        </div>
        </div>
        
     );
}
 
export default Contact;